import { Phone, ChatText } from "@phosphor-icons/react";
import { Reveal, Eyebrow } from "./Reveal";

export const Pricing = () => (
  <section id="pricing" className="border-t-2 border-line" data-testid="pricing-section">
    <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
      <Reveal>
        <Eyebrow>The price, in plain sight</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-bold uppercase leading-none tracking-tight sm:text-4xl md:text-5xl">
          No contract. Cancel anytime.
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-2 md:gap-8" data-testid="pricing-grid">
        <Reveal>
          <div className="h-full border-2 border-line bg-surface p-6 sm:p-10">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-smoke">
              One-time setup
            </p>
            <p className="mt-4 font-display text-6xl font-bold tracking-tighter text-white sm:text-7xl">
              $1,000
            </p>
            <p className="mt-2 font-mono text-sm uppercase tracking-[0.2em] text-safety">+ HST</p>
            <p className="mt-6 text-base leading-relaxed text-gray-300 sm:text-lg">
              Covers the lot: the texting number, the wait on the carriers, and the 45-minute
              go-live at your shop where we test it together.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="h-full border-2 border-safety bg-surface p-6 sm:p-10">
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-smoke">
              Then, monthly
            </p>
            <p className="mt-4 font-display text-6xl font-bold tracking-tighter text-safety sm:text-7xl">
              $650
              <span className="ml-2 align-middle font-display text-xl font-bold uppercase tracking-wide text-white sm:text-2xl">
                / month
              </span>
            </p>
            <p className="mt-2 font-mono text-sm uppercase tracking-[0.2em] text-safety">+ HST</p>
            <p className="mt-6 text-base leading-relaxed text-gray-300 sm:text-lg">
              Your missed calls get answered with a text, around the clock. Landlines and hidden
              numbers still go to voicemail, like they do now.
            </p>
          </div>
        </Reveal>
      </div>
      <Reveal className="mt-10">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-smoke">
          All prices in Canadian dollars.
        </p>
        <div className="mt-8 flex flex-col gap-4 sm:flex-row">
          <a
            href="tel:+19053517489"
            data-testid="pricing-call-button"
            className="flex min-h-[64px] items-center justify-center gap-3 bg-safety px-8 font-display text-xl font-bold uppercase tracking-wide text-asphalt transition-[background-color,transform] duration-200 hover:bg-safetydeep active:translate-y-0.5"
          >
            <Phone weight="bold" className="h-6 w-6" aria-hidden="true" />
            Call 905-351-7489
          </a>
          <a
            href="sms:+19053517489"
            data-testid="pricing-text-button"
            className="flex min-h-[64px] items-center justify-center gap-3 border-2 border-safety px-8 font-display text-xl font-bold uppercase tracking-wide text-safety transition-[background-color,color,transform] duration-200 hover:bg-safety hover:text-asphalt active:translate-y-0.5"
          >
            <ChatText weight="bold" className="h-6 w-6" aria-hidden="true" />
            Text 905-351-7489
          </a>
        </div>
        <p className="mt-6 text-sm text-smoke">
          Not sure? Call and ask. You'll get me, not a sales team.
        </p>
      </Reveal>
    </div>
  </section>
);
